var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (bundles, undefined) {
// iterate bundles
;(function(){
  var $$obj = bundles;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var bundle = $$obj[$index];

buf.push("<a" + (jade.attr("data-unread", (bundle.status !== "read" ? "true" : "false"), true, true)) + (jade.attr("data-message", bundle.message, true, true)) + (jade.attr("data-artist", bundle.object.artist.id, true, true)) + (jade.attr("href", "/works-for-you?artist_id=" + (bundle.object.artist.id) + "", true, true)) + " class=\"js-notification-bundle\"><div class=\"bundle-item\">");
if ( bundle.object.images[0].image_urls.square)
{
buf.push("<img" + (jade.attr("src", "" + (bundle.object.images[0].image_urls.square) + "", true, true)) + " class=\"bundle-image\">");
}
buf.push("<div class=\"bundle-text\"><div class=\"bundle-message\">" + (jade.escape(null == (jade_interp = bundle.message) ? "" : jade_interp)) + "</div><div class=\"bundle-actors\">" + (jade.escape(null == (jade_interp = bundle.actors) ? "" : jade_interp)) + "</div></div><div class=\"bundle-information\"><div class=\"bundle-date\">" + (jade.escape(null == (jade_interp = bundle.date) ? "" : jade_interp)) + "</div>");
if ( (bundle.status !== "read"))
{
buf.push("<div class=\"bundle-read-status\"></div>");
}
buf.push("</div></div></a>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var bundle = $$obj[$index];

buf.push("<a" + (jade.attr("data-unread", (bundle.status !== "read" ? "true" : "false"), true, true)) + (jade.attr("data-message", bundle.message, true, true)) + (jade.attr("data-artist", bundle.object.artist.id, true, true)) + (jade.attr("href", "/works-for-you?artist_id=" + (bundle.object.artist.id) + "", true, true)) + " class=\"js-notification-bundle\"><div class=\"bundle-item\">");
if ( bundle.object.images[0].image_urls.square)
{
buf.push("<img" + (jade.attr("src", "" + (bundle.object.images[0].image_urls.square) + "", true, true)) + " class=\"bundle-image\">");
}
buf.push("<div class=\"bundle-text\"><div class=\"bundle-message\">" + (jade.escape(null == (jade_interp = bundle.message) ? "" : jade_interp)) + "</div><div class=\"bundle-actors\">" + (jade.escape(null == (jade_interp = bundle.actors) ? "" : jade_interp)) + "</div></div><div class=\"bundle-information\"><div class=\"bundle-date\">" + (jade.escape(null == (jade_interp = bundle.date) ? "" : jade_interp)) + "</div>");
if ( (bundle.status !== "read"))
{
buf.push("<div class=\"bundle-read-status\"></div>");
}
buf.push("</div></div></a>");
    }

  }
}).call(this);
}.call(this,"bundles" in locals_for_with?locals_for_with.bundles:typeof bundles!=="undefined"?bundles:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;